import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { StageCard } from './StageCard';
import { STAGES, SHOW_ESTATE, fadeUp } from './data';

export const OwnershipOptions = ({ onSelect }) => {
  const stages = SHOW_ESTATE ? STAGES : STAGES.slice(0, 1);
  return (
    <section id="options" className="py-20 md:py-28 bg-[#1a1e1a]" data-testid="price-section">
      <SectionHeading eyebrow="For Sale" className="mb-12">
        {SHOW_ESTATE ? 'Two ways to own The 126' : 'What you receive'}
      </SectionHeading>

      <div className={`mx-auto px-6 md:px-12 grid gap-6 md:gap-8 ${SHOW_ESTATE ? 'max-w-6xl grid-cols-1 lg:grid-cols-2' : 'max-w-3xl grid-cols-1'}`}>
        {stages.map((s, i) => (
          <StageCard key={s.id} stage={s} featured={i === 1} delay={i * 0.15} onSelect={onSelect} />
        ))}
      </div>

      <motion.p {...fadeUp} className="max-w-3xl mx-auto px-6 md:px-12 mt-10 text-white/65 text-sm leading-relaxed text-center" data-testid="pricing-footnote">
        All prices are in New Zealand dollars and subject to contract. Furniture and chattels are excluded
        from the stated price. Images marked "architectural render" are indicative and may differ from the
        completed home.
      </motion.p>
    </section>
  );
};
